import { _request, APIMethod } from '..';
import { buildQueryParams } from '../apiHelpers';

import * as apiTypes from './TenantUserMembershipApiTypeDefs';

const TENANTS_PATH_PREFIX = '/tenants';
const USERS_PATH_PREFIX = 'usertenantmemberships';
const PROFILES_PREFIX = '/profiles';
const USERS_PREFIX = '/users';

export const APITenantUserMembershipGetList: APIMethod<apiTypes.APITenantUserMembershipGetParams, apiTypes.APITenantUserMembershipGetResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}`)
);

export const APITenantUserMembershipGetPaginatedList: APIMethod<apiTypes.APITenantUserMembershipGetPaginatedListParams, apiTypes.APITenantUserMembershipGetPaginatedListResponse> = (params) => {
    const queryParams = buildQueryParams(params,
        [
            { key : 'status' },
            { key : 'globalRoles', getValue : globalRole => globalRole.id }
        ]);

    const apiPath = `${PROFILES_PREFIX}${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}`;
    const requestPath = `${apiPath}` + (queryParams && `?${queryParams}`);
    return _request('GET', requestPath, undefined, params.signal, params.retries);
};

export const APITenantUserMembershipPost: APIMethod<apiTypes.APITenantUserMembershipPostParams, apiTypes.APITenantUserMembershipPostResponse> = params => (
    _request(
        'POST',
        `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}`,
        params)
);

export const APITenantUserMembershipDelete: APIMethod<apiTypes.APITenantUserMembershipDeleteParams, apiTypes.APITenantUserMembershipDeleteResponse> = params => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}/${params.userId}`)
);

export const APITenantUserMembershipPut: APIMethod<apiTypes.APITenantUserMembershipPutParams, apiTypes.APITenantUserMembershipPutResponse> = params => (
    _request(
        'PUT',
        `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}/${params.userId}`,
        params)
);

export const APITenantUserMembershipGetSingle: APIMethod<apiTypes.APITenantUserMembershipGetSingleParams, apiTypes.APITenantUserMembershipGetSingleResponse> = params => (
    _request('GET', `${PROFILES_PREFIX}${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}/${params.userId}?includeCounts=true`)
);

export const APIUserTenantMembershipGet: APIMethod<apiTypes.APIUserTenantMembershipGetParams, apiTypes.APIUserTenantMembershipGetResponse> = params => (
    _request('GET', `${USERS_PREFIX}/${params.userId}/${USERS_PATH_PREFIX}?includeCounts=true`)
);

export const APITenantUserProfileMembershipDelete: APIMethod<apiTypes.APITenantUserMembershipDeleteParams, apiTypes.APITenantUserMembershipDeleteResponse> = params => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USERS_PATH_PREFIX}/${params.userId}?force=true`)
);
